// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"47":"ee72aac9055692b68c49","184":"90af55213d4f3cd8c13b","642":"afaa9d745560f0d39274"}[chunkId] + ".css";
};